import React, { useEffect, useState } from 'react';
import axios from 'axios';
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from './ui/select';

const API = process.env.REACT_APP_BACKEND_URL;

/**
 * Compact season switcher — Admin-only opt-in filter for analytics surfaces.
 *
 * Props:
 *   value:    string | ''    (season_id; '' means "no filter" = default behavior)
 *   onChange: (season_id: string | '') => void
 */
const SeasonSwitcher = ({ value = '', onChange, testId = 'season-switcher', adminOnly = true, userRole }) => {
  const [seasons, setSeasons] = useState([]);

  useEffect(() => {
    const h = { headers: { Authorization: `Bearer ${localStorage.getItem('token')}` } };
    axios.get(`${API}/api/seasons`, h).then((r) => setSeasons(r.data || [])).catch(() => {});
  }, []);

  // Staff/Player/Parent don't get the switch unless explicitly allowed.
  if (adminOnly && userRole && userRole !== 'Admin') return null;
  if (seasons.length === 0) return null;

  return (
    <div className="w-52" data-testid={testId}>
      <Select value={value || '__all__'} onValueChange={(v) => onChange(v === '__all__' ? '' : v)}>
        <SelectTrigger className="h-8 text-xs">
          <SelectValue />
        </SelectTrigger>
        <SelectContent>
          <SelectItem value="__all__" data-testid={`${testId}-all`}>All Seasons</SelectItem>
          {seasons.map((s) => (
            <SelectItem key={s.id} value={s.id} data-testid={`${testId}-${s.id}`}>
              {s.name}{s.is_current ? ' (current)' : ''}
            </SelectItem>
          ))}
        </SelectContent>
      </Select>
    </div>
  );
};

export default SeasonSwitcher;
